import { useState, useRef, useEffect } from 'react';

export const useTouchClick = (onClickCallback, threshold = 10, onSlideCallback, shouldStopPropagation = false) => {
    const [touchStartPos, setTouchStartPos] = useState({ x: 0, y: 0 });
    const lastTouchTime = useRef(0);
    const isDragging = useRef(false);
    const totalDeltaX = useRef(0);  // 누적 deltaX 추적

    // const handleTouchStart = (e) => {
    //     if (shouldStopPropagation) e.stopPropagation(); // 전파 방지 옵션 적용
    //     setTouchStartPos({
    //         x: e.touches[0].clientX,
    //         y: e.touches[0].clientY
    //     });
    // };



    const handlePointerDown = (e) => {
        if (shouldStopPropagation) e.stopPropagation();
        isDragging.current = true;
        totalDeltaX.current = 0;  // 초기화
        setTouchStartPos({
            x: e.clientX,
            y: e.clientY
        });
        console.log('Touch Start:', { x: e.clientX, y: e.clientY });
    };

    const handlePointerMove = (e) => {
        if (!isDragging.current) return;

        const currentPos = {
            x: e.clientX,
            y: e.clientY
        };

        const deltaX = touchStartPos.x - currentPos.x;
        totalDeltaX.current = deltaX;  // 누적

        console.log('Dragging - Total Delta X:', totalDeltaX.current);
    };

    const handlePointerUp = (e) => {
        if (!isDragging.current) return;

        isDragging.current = false;
        const now = Date.now();
        if (now - lastTouchTime.current < 500) return;

        lastTouchTime.current = now;
        console.log('Touch End - Total Delta X:', totalDeltaX.current);

        if (Math.abs(totalDeltaX.current) > threshold) {
            onSlideCallback && onSlideCallback(-totalDeltaX.current);
        } else {
            onClickCallback && onClickCallback(e);
        }

        totalDeltaX.current = 0;  // 리셋
    };



    const handlePointerLeave = (e) => {
        // 포인터가 떠날 때도 슬라이드 체크
        if (isDragging.current && Math.abs(totalDeltaX.current) > threshold) {
            console.log('Pointer Leave - Processing slide with Delta X:', totalDeltaX.current);
            onSlideCallback && onSlideCallback(-totalDeltaX.current);
        }
        isDragging.current = false;
        totalDeltaX.current = 0;
    };



    // const handleTouchEnd = (e) => {
    //     if (shouldStopPropagation) e.stopPropagation(); // 전파 방지 옵션 적용
    //     const now = Date.now();
    //     if (now - lastTouchTime.current < 500) {
    //         return; // 0.5초 이내에 터치가 발생하면 무시
    //     }
    //     lastTouchTime.current = now; // 마지막 터치 시간을 갱신

    //     const touchEndPos = {
    //         x: e.changedTouches[0].clientX,
    //         y: e.changedTouches[0].clientY
    //     };
    //     const deltaX = touchStartPos.x - touchEndPos.x;
    //     const deltaY = touchStartPos.y - touchEndPos.y;

    //     // if (Math.abs(deltaX) > threshold || Math.abs(deltaY) > threshold) {
    //     if (Math.abs(deltaX) > threshold) {
    //         onSlideCallback && onSlideCallback(deltaX, deltaY, e);
    //     } else {
    //         onClickCallback && onClickCallback(e);
    //     }
    // };
    const handleTouchStart = (e) => {
        if (shouldStopPropagation) e.stopPropagation(); // 전파 방지 옵션 적용
        setTouchStartPos({
            x: e.clientX, // PointerEvent는 touches 배열이 없음
            y: e.clientY
        });
    };


    const handleTouchEnd = (e) => {
        if (shouldStopPropagation) e.stopPropagation(); // 전파 방지 옵션 적용

        const now = Date.now();
        if (now - lastTouchTime.current < 500) {
            return; // 0.5초 이내에 터치가 발생하면 무시
        }
        lastTouchTime.current = now; // 마지막 터치 시간을 갱신

        const touchEndPos = {
            x: e.clientX, // PointerEvent에서 직접 clientX 사용
            y: e.clientY
        };

        const deltaX = touchStartPos.x - touchEndPos.x;
        const deltaY = touchStartPos.y - touchEndPos.y;

        if (Math.abs(deltaX) > threshold) {
            onSlideCallback && onSlideCallback(deltaX, deltaY, e);
        } else {
            onClickCallback && onClickCallback(e);
        }
    };



    return {
        handleTouchStart,
        handleTouchEnd,
        handlePointerDown,
        handlePointerMove,
        handlePointerUp,
        handlePointerLeave
    };
};
